import React from 'react';

import { Header } from 'components';
import { DocumentsOverview } from '../../components';

export const Documents = () => {
  return (
    <>
      <Header />
      <DocumentsOverview />
    </>
  );
};
